import type React from "react";
import { useEffect, useState } from "react";
import {
	Route,
	BrowserRouter as Router,
	Routes,
	useNavigate,
} from "react-router-dom";
import { MainLayout } from "../layouts/MainLayout";
import { consumeReturnUrl } from "../utils/auth";
import { CheckInPage } from "./checkin-page";
import { EventDetailPage } from "./event-detail-page/event-detail-page";
import { EventsPage } from "./events-page/events-page";
import { GuestAppendPage } from "./guest-append-page";
import { KioskPage } from "./kiosk-page";
// import { IndexPage } from "./index-page/index-page";
import { LoginPage } from "./login-page/login-page";

const RedirectHandler: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => {
	const navigate = useNavigate();
	const [targetUrl] = useState(() => consumeReturnUrl());

	useEffect(() => {
		if (targetUrl) {
			navigate(targetUrl, { replace: true });
		}
	}, [targetUrl, navigate]);

	if (targetUrl) {
		return null; // Don't render children if we are redirecting
	}

	return <>{children}</>;
};

const Navigator = () => {
	// Access Redux store using useSelector hook if needed
	// const accountReducer = useSelector((store) => store.AccountReducer);

	return (
		<Router>
			<Routes>
				<Route
					path="/"
					element={
						<RedirectHandler>
							<MainLayout>
								<EventsPage />
							</MainLayout>
						</RedirectHandler>
					}
				/>
				<Route path="/login" element={<LoginPage />} />
				<Route
					path="/events"
					element={
						<MainLayout>
							<EventsPage />
						</MainLayout>
					}
				/>
				<Route
					path="/events/:id"
					element={
						<MainLayout hidePromoBar={false}>
							<EventDetailPage />
						</MainLayout>
					}
				/>
				<Route path="/events/:id/kiosk" element={<KioskPage />} />
				<Route path="/events/:id/append" element={<GuestAppendPage />} />
				<Route path="/join" element={<GuestAppendPage />} />
				<Route path="/checkin" element={<CheckInPage />} />
			</Routes>
		</Router>
	);
};

export { Navigator };
